import {
  getInitMenu,
  getDocument,
  deleteMenu,
  get,
  ApiCreateTwoLevelTitle,
  updateDocumentAndTitle,
  saveDocumentApi
} from '@/assets/js/fetch'
import * as types from '../mutation-types'

const state = {
  // 侧边栏数据
  asideMenu: [],
  // 是否显示发布块和是否允许发布
  public: {
    isShow: true,
    isPublic: false,
    id: '', // 待发布的id
    parentName: '',
    name: '' // 待发布的名字
  },
  // 获取文档详情
  secondDocData: {},
  firstDocData: {},
  isLogin: false,
  userInfo: {},
  cloneData: {},
  isGetCloneDate: false // 是否获取clone数据
}

const getters = {
  asideMenu(state) {
    return state.asideMenu
  },
  // 取得一二级联动数据
  getTitleCascader(state) {
    const arr = []
    state.asideMenu.forEach(item => {
      if (item.children && item.children.length) {
        const obj = {}
        obj.label = item.name
        obj.value = item.id
        obj.children = []
        if (item.children) {
          item.children.forEach(childItem => {
            if (childItem.status !== '-1') {
              obj.children.push({
                label: childItem.name,
                value: childItem.id
              })
            }
          })
        }
        arr.push(obj)
      }
    })
    return arr
  },
  getPuclicStatus(state) {
    return state.public
  },
  getParentMenu(state) {
    const paremt = {}
    state.asideMenu.forEach(item => {
      if (item.children) {
        item.children.forEach(childItem => {
          paremt[childItem.id] = childItem
        })
      }
    })
    return paremt
  },
  getChildMenu(state) {
    const child = {}
    state.asideMenu.forEach(item => {
      const children = item.children
      if (children.length) {
        children.forEach(childrens => {
          if (childrens.children) {
            childrens.children.forEach(twoChild => {
              child[twoChild.id] = twoChild
            })
          }
        })
      }
    })
    return child
  },
  getSecondDocData(state) {
    return state.secondDocData
  },
  getFirstDocData(state) {
    return state.firstDocData
  },
  getLoginStatus(state) {
    return state.isLogin
  },
  getUserInfo(state) {
    return state.userInfo
  },
  getCloneData(state) {
    return state.cloneData
  },
  getCloneDataStatus(state) {
    return state.isGetCloneDate
  }
}

const mutations = {
  [types.SET_ASIDE_MENU](state, params) {
    state.asideMenu = params
  },
  [types.SET_PUBLIC_STATE](state, params) {
    state.public.isPublic = params.isPublic
    state.public.id = params.id || ''
    state.public.name = params.name || ''
    state.public.parentName = params.parentName || ''
  },
  [types.SET_SECOND_DOCUMENT](state, params) {
    state.secondDocData = params
  },
  [types.SET_FIRST_DOCUMENT](state, params) {
    state.firstDocData = params
  },
  [types.SET_LOGIN_STATUS](state, params) {
    if (params === -999) {
      state.isLogin = false
    } else {
      state.isLogin = true
      state.userInfo = params
    }
  },
  [types.SET_CLONE_DATA](state, params) {
    state.cloneData = params
  },
  [types.SET_IS_GET_CLONE_STATUS](state, params) {
    state.isGetCloneDate = params
  }
}

const actions = {
  // 获取左侧导航栏
  async getAsideInitMenu({ commit }) {
    const res = await getInitMenu()
    commit(types.SET_ASIDE_MENU, res.data.value.menus)
    return res
    // return new Promise((resolve, reject) => {
    //   getInitMenu('initMenu')
    //     .then(res => {
    //       commit(types.SET_ASIDE_MENU, res.data.value.menus)
    //       resolve(res)
    //     })
    //     .catch(err => {
    //       reject(err)
    //     })
    // })
  },
  // 创建二级标题
  async createTwoLevelTitle({ dispatch }, data) {
    const res = await ApiCreateTwoLevelTitle(data)
    dispatch('getAsideInitMenu')
    return res
  },
  // 保存文档
  async saveApiDoc({ dispatch, getters }, apiParams) {
    const res = await saveDocumentApi(apiParams)
    if (res.data.value) {
      dispatch('changePublicState', {
        isPublic: true,
        name: res.data.value.name,
        id: res.data.value.id,
        parentName: getters.getParentMenu[apiParams.parent_id].name
      })
      dispatch('getAsideInitMenu')
    }
    return res
  },
  // 改变发布状态
  changePublicState({ commit }, params) {
    commit(types.SET_PUBLIC_STATE, params)
  },
  // 获取文档信息
  async getDocumentDetail({ commit, getters, dispatch }, params) {
    const res = await getDocument(params)
    const data = res.data.value
    commit(types.SET_SECOND_DOCUMENT, data)
    dispatch('changePublicState', {
      isPublic: data.status === '0',
      name: data.name,
      id: data.menu_id,
      parentName: data.parent_name
    })
    return res
  },
  // 获取一级标题信息
  getFirstDocDetail({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      dispatch('changePublicState', {
        isPublic: false
      })
      getDocument(params)
        .then(res => {
          if (res.data.value) {
            commit(types.SET_FIRST_DOCUMENT, res.data.value)
          } else {
            reject(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存一级名称
  // saveFirstDoc({ dispatch }, params) {
  //   return new Promise((resolve, reject) => {
  //     saveDocument('saveMenu', params).then(res => {
  //       resolve(res)
  //       if (res.data.value) {
  //         dispatch('getAsideInitMenu')
  //       }
  //     })
  //   })
  // },
  // 更新文档信息
  async updateSecondDoc({ dispatch, rootState, getters }, params) {
    const res = await updateDocumentAndTitle(params)
    await dispatch('getAsideInitMenu')
    dispatch('getDocumentDetail', {
      level: 3,
      id: rootState.route.params.id
    })
    return res
  },
  // 更新标题
  async updateTitle({ dispatch }, data) {
    const res = await updateDocumentAndTitle(data)
    dispatch('getAsideInitMenu')
    return res
  },
  // updateFirstDoc({ dispatch }, params) {
  //   return new Promise((resolve, reject) => {
  //     updateDocument('updateMenu', params)
  //       .then(res => {
  //         resolve(res)
  //         if (res.data.value) {
  //           dispatch('getAsideInitMenu')
  //         }
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  // 删除文档标题
  async deleteTitle({ dispatch, rootState }, data) {
    const res = await deleteMenu(data)
    await dispatch('getAsideInitMenu')
    return res
  },
  deleteScondDoc({ dispatch, rootState }, params) {
    return new Promise((resolve, reject) => {
      deleteMenu('deleteMenu', params)
        .then(res => {
          resolve(res)
          if (res.data.value > 0) {
            dispatch('getAsideInitMenu').then(res => {
              dispatch('getDocumentDetail', {
                level: 2,
                id: rootState.route.params.id
              })
            })
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除一级标题
  // deleteFirstDoc({ dispatch, rootState }, params) {
  //   return new Promise((resolve, reject) => {
  //     deleteMenu('deleteMenu', params)
  //       .then(res => {
  //         resolve(res)
  //         if (res.data.value > 0) {
  //           dispatch('getAsideInitMenu')
  //           if (/second/.test(rootState.route.params.id)) {
  //             dispatch('getDocumentDetail', {
  //               level: 2,
  //               id: rootState.route.params.id
  //             })
  //           }
  //         }
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  getLoginStatus({ commit }) {
    return new Promise((resolve, reject) => {
      get('account/get')
        .then(res => {
          commit(types.SET_LOGIN_STATUS, res.data.value)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  cloneDocument({ commit }, params) {
    commit(types.SET_CLONE_DATA, params)
  },
  setIsGetCloneStatus({ commit }, params) {
    commit(types.SET_IS_GET_CLONE_STATUS, params)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/module.js